module.exports = __webpack_public_path__ + "media/images/flags/64/Singapore-326d3d8ad674cc77ef397bc7c672ed16.png";